import { useEffect } from 'react'
import Loading from './Loading'
import { useAuth } from "@clerk/clerk-react"
import { useNavigate } from "@tanstack/react-router"
import { omniStorage, storage } from '@/helpers'
import { webrtc } from '@/providers/MfdProvider'

const Logout = () => {
  const { signOut } = useAuth()
  const navigate = useNavigate()

  const logout = () => {
    omniStorage.removeAll()
    storage.removeAll()

    if (!(window as any)?.flutter_inappwebview?.callHandler) {
      if ((window as any)?.Android) {
        (window as any).Android.clearToken()
      }
      if ((window as any)?.Amazon) {
        (window as any).Amazon.clearToken()
      }
    }

    webrtc?.stop?.()
    localStorage.clear()
    sessionStorage.clear()
    storage.removeAll()
  }

  useEffect(() => {
    if (!signOut) {
      return
    }
    void Promise.all([
      signOut(),
      logout(),
      (window as any)?.flutter_inappwebview?.callHandler?.('logout')
    ]).finally(() => navigate({ to: '/login' }))
  }, [signOut])

  return <Loading />
}

export default Logout
